import {NgModule} from '@angular/core';
import {ButtonModule, ConfirmationService, ConfirmDialogModule} from "primeng";
import {KlConfirmDialogComponent} from "./confirm-dialog.component";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    KlConfirmDialogComponent
  ],
  imports: [
    ButtonModule,
    ConfirmDialogModule,
    TranslateModule,
  ],
  exports: [
    KlConfirmDialogComponent
  ],
  providers: [
    ConfirmationService
  ]
})
export class KlConfirmDialogModule { }
